import appConfig from "../../config";
import { getLocalStorageInfo } from "../../utils";

export const ABLInstance =  appConfig.env.key === "api" ? [397].includes(getLocalStorageInfo()?.defaultLessor?.id):[545].includes(getLocalStorageInfo()?.defaultLessor?.id);
